import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import { createUIDefinition } from '../default-task-definition'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { selectCustomer } from '../../../../customer/state/detail/selector'

export default createUIDefinition({
    taskName: taskName.UPLOAD_SCAN_FILES_MANUALLY,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.CUSTOMER_CONTACT_WIDGET,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
        },
        {
            component: processUI.SALES_ORDER_CUSTOMER_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
    ],
    taskValidatorSelector: [
        selectCustomer,
    ],
    taskValidator: (task, processInstance, taskName, eventName, customer) => {
        if (!customer.scanFileList || customer.scanFileList.length < 2) {
            return [
                createValidationMessage('Please upload at least 2 scan files.', 'scan_file_upload_length'),
            ]
        }

        return []
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/in-shop-scan/upload-scan-files-manually.js